/**
 * @copyright Copyright 2024 Epic Systems Corporation
 * @file functions to get data for app download page
 * @module Epic.AppOrchard.Data.DownloadApp
 */

import { IGenericAPIResponse } from "ao/data";
import { DUQVisibility } from "ao/types/questionnaireVersion";
import { IShowroomAppDownloadModel } from "ao/types/showroom";
import api from "ao/utils/api";

export interface IDownloadAppModelResponse extends IGenericAPIResponse {
	model: IShowroomAppDownloadModel;
}

export async function getDetails(appId: number): Promise<IDownloadAppModelResponse> {
	return await api.get<IDownloadAppModelResponse>(`/api/Download/Details?appId=${appId.toString()}`);
}

export async function findAppWithClientId(clientId: string): Promise<IGenericAPIResponse> {
	return await api.get<IGenericAPIResponse>(`/api/Download/FindApp?clientId=${clientId}`);
}

export async function setDuqVisibility(
	appId: number,
	duqVisibility: DUQVisibility,
): Promise<IGenericAPIResponse> {
	return await api.post<IGenericAPIResponse>("/api/Download/SetDuqVisibility", { appId, duqVisibility });
}
